import React from 'react'

import TermConditionData from './Data/TermConditionData'

function TermCondition() {
  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto bg-white shadow-xl rounded-lg overflow-hidden">
        {/* Header */}
        <div className="bg-green-600 text-white p-6">
          <h1 className="text-2xl sm:text-3xl font-bold text-center">
            Syarat & Ketentuan Papa Kilo Hairstudio
          </h1>
          <p className="text-center text-green-100 mt-2">
            Terakhir Diperbarui: {new Date().toLocaleDateString()}
          </p>
        </div>

        {/* Content */}
        <div className="p-6 space-y-6">
          {TermConditionData.map((section, index) => (
            <div key={index} className="border-b pb-4 last:border-b-0">
              <h2 className="text-xl font-semibold text-green-700 mb-3">
                {section.title}
              </h2>
              <p className="text-gray-700 leading-relaxed">
                {section.content}
              </p>
            </div>
          ))}
        </div>

        {/* Footer */}
        <div className="bg-gray-100 p-6 text-center">
          <p className="text-sm text-gray-600">
            © {new Date().getFullYear()} Papa Kilo Hairstudio
          </p>
        </div>
      </div>
    </div>
  )
}

export default TermCondition